import styled from "styled-components";

export const Apresentacao = styled.div`
  width: 100vw;
  max-width: 1300px;
  height: 800px;
  padding: 43px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;
    width: 100%;

    #seLiga {
      font-weight: 700;
      font-size: 12px;
      line-height: 140%;
      text-transform: uppercase;
      text-align: left;
      width: 100%;
      color: var(--orange);
    }

    h1 {
      font-weight: 700;
      font-size: 28px;
      line-height: 122%;

      span {
        color: var(--orange);
      }
    }

    p {
      font-size: 14px;
      line-height: 150%;

      span {
        color: var(--orange);
        font-weight: 700;
      }
    }
    
    button {
      width: 256px;
      height: 40px;
      border: none;
      border-radius: 2px;
      background-color: var(--blue);
      
      margin: 40px 0;
      
      a {
        width: 100%;
        height: 100%;
        font-weight: 500;
        font-size: 12px;
        line-height: 150%;
        color: var(--white);
        
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  figure {
    width: 100%;

    img {
      width: 100%;
    }
  }

  @media (min-width: 601px) {
    margin: 0 auto;
    height: 695px;
    flex-direction: row;
    
    div {
      align-items: flex-start;
      gap: 0px;
      width: 50%;
      justify-content: space-around;

      #seLiga {
        font-size: 16px;
      }

      h1 {
        font-size: 50px;
        line-height: 130%;
      }

      p {
        font-size: 18px;
        line-height: 148%;
      }

      button {
        width: 240px;
        height: 56px;
        font-size: 14px;
        margin: 40px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 7px;
        
        :hover {
            background-color: var(--title);
            transition: all .3s;
        }

        #icon {
            font-size: 18px;
            margin-top: 2px;
        }
    }
    }

    figure {
      width: 50%;

      img {
        width: 100%;
      }
    }
  }
`;
